var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCamera = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 28.5714C0.666504 12.7919 13.4584 0 29.2379 0H72.0951C87.8746 0 100.667 12.7919 100.667 28.5714V71.4286C100.667 87.2081 87.8746 100 72.0951 100H29.2379C13.4584 100 0.666504 87.2081 0.666504 71.4286V28.5714Z",
    fill: "url(#paint0_linear_449_873)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0857 72.5539H35.1572C26.6929 72.5539 23.8804 66.9289 23.8804 61.2771V38.7236C23.8804 30.2593 26.6929 27.4468 35.1572 27.4468H52.0857C60.55 27.4468 63.3625 30.2593 63.3625 38.7236V61.2771C63.3625 69.7414 60.5232 72.5539 52.0857 72.5539Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8092 63.6612L63.3628 58.438V41.5362L70.8092 36.313C74.4521 33.7683 77.4521 35.3219 77.4521 39.7951V60.2058C77.4521 64.679 74.4521 66.2326 70.8092 63.6612Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3269 47.3214C51.5459 47.3214 53.3448 45.5225 53.3448 43.3035C53.3448 41.0845 51.5459 39.2856 49.3269 39.2856C47.1079 39.2856 45.3091 41.0845 45.3091 43.3035C45.3091 45.5225 47.1079 47.3214 49.3269 47.3214Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_873",
    x1: 50.6665,
    y1: 0,
    x2: 50.6665,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCamera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Camera.29534af7.svg";
export { ForwardRef as ReactComponent };